const getLocalState = state => state.pages.playlist || {}

export const getPlaylistInfos = getLocalState



// WEBPACK FOOTER //
// ./src/pages/playlist/playlistSelectors.js